import React from 'react';
import { ToastContainer, ToastTransition, cssTransition } from 'react-toastify';

const fade: ToastTransition = cssTransition({
    enter: 'Toastify__slide-enter-common',
    exit: 'Toastify__slide-exit-common',
});

const ToastBodyContainer = () => (
    <ToastContainer
        position="bottom-center"
        transition={fade}
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        style={{ whiteSpace: 'pre-line', left: '0px', right: '0px', transform: 'none', bottom: '30px', '--toastify-toast-min-height': '44px', padding: '0px' } as React.CSSProperties}
        className="!w-auto"
    />
);

export default ToastBodyContainer;
